export var getFormattedDate = function (_a) {
    var locale = _a.locale, timestamp = _a.timestamp;
    return formatWithIntl({ month: 'long', day: '2-digit' }, timestamp, locale);
};
export var getFormattedTime = function (_a) {
    var locale = _a.locale, timestamp = _a.timestamp;
    return formatWithIntl({
        minute: '2-digit',
        hour: 'numeric',
    }, timestamp, locale);
};
export var getFormattedDateTime = function (_a) {
    var timestamp = _a.timestamp, locale = _a.locale;
    return formatWithIntl({
        year: 'numeric',
        month: 'long',
        day: '2-digit',
        minute: '2-digit',
        hour: 'numeric',
    }, timestamp, locale);
};
export var formatWithIntl = function (options, timestamp, locale) {
    return new Intl.DateTimeFormat(locale || 'en', options).format(new Date(timestamp));
};
//# sourceMappingURL=formatter.js.map